import React, { useState } from "react";
import NavbarThree from "../../Components/Navbar/navbarThree";
import MapsPage from "./mapsPages";
import Footer from "../../Components/Footer";

const PageMapsTwo = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <NavbarThree isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

      <div className="pt-24 font-signika">
        <MapsPage />
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default PageMapsTwo;
